
import {TLocaleDateFormat, LocaleDateFormatEnum} from '../../../features/settings-new/models';

export class DateUtils {

  static dateToString(
    date: Date | string | null | undefined,
    format: TLocaleDateFormat = LocaleDateFormatEnum.DEFAULT,
    locale: string | Intl.Locale | readonly (Intl.UnicodeBCP47LocaleIdentifier | Intl.Locale)[] = 'en-GB',
  ): string | null {
    if (!date) return 'No Date Found';
    const dt = new Date(date);
    if (isNaN(dt.getTime())) {
      return null;
    }
    return dt.toLocaleDateString(
      locale,
      DateUtils.getLocaleDateOptions(format),
    );
  }

  private static getLocaleDateOptions(
    format: TLocaleDateFormat,
  ): Intl.DateTimeFormatOptions {
    switch (format) {
      case LocaleDateFormatEnum.MEDIUM:
        return {year: 'numeric', month: 'short', day: 'numeric'};

      case LocaleDateFormatEnum.LONG:
        return {year: 'numeric', month: 'long', day: 'numeric'};

      case LocaleDateFormatEnum.FULL:
        return {
          weekday: 'long',
          year: 'numeric',
          month: 'long',
          day: 'numeric',
        };

      case LocaleDateFormatEnum.WEEKDAY_MONTH_DAY_YEAR:
        return {
          weekday: 'short',
          month: 'long',
          day: 'numeric',
          year: 'numeric',
        };

      case LocaleDateFormatEnum.NUMERIC_MONTH_DAY_YEAR:
        return {
          month: '2-digit',
          day: '2-digit',
          year: 'numeric',
        };

      case LocaleDateFormatEnum.TIME_SHORT:
        return {
          hour: '2-digit',
          minute: '2-digit',
        };

      case LocaleDateFormatEnum.DATETIME_MEDIUM:
        return {
          ...this.getLocaleDateOptions(LocaleDateFormatEnum.MEDIUM),
          ...this.getLocaleDateOptions(LocaleDateFormatEnum.TIME_SHORT),
        };

      case LocaleDateFormatEnum.DATETIME_LONG:
        return {
          ...this.getLocaleDateOptions(LocaleDateFormatEnum.LONG),
          ...{hour: 'numeric', minute: 'numeric', second: 'numeric', timeZoneName: 'short'},
        };

      case LocaleDateFormatEnum.FULL_DATETIME:
        return {
          ...this.getLocaleDateOptions(LocaleDateFormatEnum.FULL),
          ...{hour: 'numeric', minute: 'numeric', second: 'numeric', timeZoneName: 'short'},
        };

      case LocaleDateFormatEnum.DEFAULT:
      default:
        return {
          weekday: 'short',
          day: '2-digit',
          month: 'short',
          year: 'numeric',
        };
    }
  }
}
